module.exports = __webpack_public_path__ + "img/location.3ba9e4d5.svg";